import { Alert } from 'appkit-react';
import React, { useEffect, useState } from 'react';

import '../styles/custom-alert.scss';
import CustomPieChartLoader from './CustomPieChartLoader';
import { ToastTypeEnum } from '../../../constants';

const CustomAlert = ({
    message, confirmation, undoAction, setShowDeleteToast, type = ToastTypeEnum.SUCCESS,
}) => {
    const [timer, setTimer] = useState(5);
    const [loaderTime, setLoaderTime] = useState(80);
    const id = React.useRef(null);
    const loader = React.useRef(null);
    const clear = () => {
        window.clearInterval(id.current);
    };

    const clearLoader = () => {
        window.clearInterval(loader.current);
    };

    useEffect(() => {
        id.current = window.setInterval(() => {
            setTimer(time => time - 1);
        }, 1000);
        return () => clear();
    }, []);

    useEffect(() => {
        loader.current = window.setInterval(() => {
            setLoaderTime(loaderCount => loaderCount - 1);
        }, 62.5);
        return () => clear();
    }, []);

    useEffect(() => {
        if (timer === 0) {
            clear();
            clearLoader();
            confirmation(true);
            setShowDeleteToast(false);
        }
    }, [timer]);

    const undoHandler = () => {
        clear();
        confirmation(false);
        undoAction();
    };

    const customMessage = (
        <div style={{ display: 'flex' }}>
            <span className="custom-unto-alert-message">{message}</span>

            {timer > 0 && <span className="custom-unto-alert-loader"><CustomPieChartLoader percentage={loaderTime} /></span>}

            {timer > 0 && (
                <span
                    className="custom-unto-alert-undo-btn"
                    onClick={undoHandler}
                    role="presentation"
                >
                    Undo
                </span>
            )}
        </div>
    );
    return (
        <Alert
            duration={0}
            status={type}
            message={customMessage}
            closeable
            onClose={() => confirmation(true)}
            className="custom-unto-alert"
        />
    );
};

export default CustomAlert;
